// const baseSize = 80 //基础系数就是上面的rootValue
// let isApp = /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(
//     navigator.userAgent
// )
// const setHtmlFontSize = () => {
//   const htmlDom = document.getElementsByTagName('html')[0]
//   let htmlWidth =
//     document.documentElement.clientWidth || document.body.clientWidth
//   if (htmlWidth >= 750) {
//     htmlWidth = 800
//   }
//   if (htmlWidth <= 320) {
//     htmlWidth = 320
//   }
//   if(isApp){
//     htmlDom.style.fontSize = `${(htmlWidth / 480) * baseSize}px`
//   }else{
//       htmlDom.style.fontSize = `${(htmlWidth / 800) * baseSize}px`
//   }
// }
// window.onresize = setHtmlFontSize
// setHtmlFontSize()

// const px2rem = (px: any) => {
//   if (/%/gi.test(px)) {
//     // 有百分号%，特殊处理，表述pc是一个有百分号的数，比如：90%
//     return px
//   } else {
//     return parseFloat(px) / 37.5 + 'rem' // 这里的37.5，和rootValue值对应
//   }
// }

const w: any = window
if (w.__MICRO_APP_ENVIRONMENT__) {
  __webpack_public_path__ = w.__MICRO_APP_PUBLIC_PATH__
}

import './init.js'
import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import installIndex from './appUse/index'
import './appUse/style'
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
// import installErrorPlugins from './plugins/errorPlugins'
import installI18n from './appUse/i18n'
// import api from '@/api/index.js'
import Bus from '@/utils/eventBus'
import { customConfirm } from '@/utils/customConfirm'
import '@/icons/index.js'
// import { initCollect } from '@/utils/analytics'
import Validator from '@/utils/validator'
import env from '@/env'
import 'animate.css'

const app = createApp(App)
// initCollect() //初始化火山引擎埋点

const SITE_ENV = document.querySelector('html')?.getAttribute('SITE_ENV')
console.log('env', process.env.VUE_APP_TICO_ENV, process.env.NODE_ENV)

// app.config.globalProperties.$api = api
app.config.globalProperties.$bus = new Bus()
app.config.globalProperties.$customConfirm = customConfirm
app.config.globalProperties.$Validator = Validator
app.config.globalProperties.$env = env
app.config.globalProperties.$SITE_ENV = SITE_ENV

installIndex(app)
// installErrorPlugins(app)
installI18n(app)
// app.use(ElementPlus)
app.use(store).use(router).mount('#app')
